<template>
    <div class="analytics-incorrects">
        <AnalyticsIncorrectsMode
            class="analytics-incorrects__mode--phonemic-vowel"
            :showPreloader="showPreloader"
            type="phonemicVowel" />
        <AnalyticsIncorrectsMode
            class="analytics-incorrects__mode--phonemic-consonant"
            :showPreloader="showPreloader"
            type="phonemicConsonant" />
        <AnalyticsIncorrectsMode
            class="analytics-incorrects__mode--phonetic-vowel"
            :showPreloader="showPreloader"
            type="phoneticVowel" />
        <AnalyticsIncorrectsMode
            class="analytics-incorrects__mode--phonetic-consonant"
            :showPreloader="showPreloader"
            type="phoneticConsonant" />
        <span class="analytics-incorrects__connection-line analytics-incorrects__connection-line--phonemic-vowel"></span>
        <span class="analytics-incorrects__connection-line analytics-incorrects__connection-line--phonemic-consonant"></span>
    </div>
</template>
<script>
    import AnalyticsIncorrectsMode from '@/components/AnalyticsIncorrectsMode.vue';
    export default {
        components: {
            AnalyticsIncorrectsMode,
        },

        data(){
            return {
                showPreloader: true,
            };
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsIncorrects)
                .then(response => response.json())
                .then(incorrectsData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsCorrectness',
                        dataLabel: 'incorrectsData',
                        data: incorrectsData
                    });
                    this.showPreloader = false;
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsCorrectnessIncorrectMode, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(incorrectsData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsCorrectness',
                        dataLabel: 'incorrectsData',
                        data: incorrectsData
                    });
                    this.showPreloader = false;
                })
                .catch(err => {
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                });
            }
        }
    };
</script>
<style scoped src="@/css/components/analytics-incorrects.css"></style>